export enum ErrorType {
  UserEnrollmentError = 1,
}
